import type transform from '../to/persons';

export default (persons: ReturnType<typeof transform>) => {
  if (persons.length != new Set(persons.map(x => x.id)).size)
    throw new Error('(Core::From::V2::Persons) Persons array have two or more persons with the same ID');

  return persons
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::Persons) Person id is undefined');

      return { ...x };
    });
};
